export const NOTIFICATION_SETTINGS_PATH = '/notifications';

export const routePaths = {
  NOTIFICATION_SETTINGS_PATH
};

export default routePaths;
